import { Form, Col, Card, Row } from 'react-bootstrap';
import { Field } from 'react-final-form';
import { camporadio, campotexto } from '../../forms/campos/campos';
import Bodychildren from '../../../utils/Bodychildren';

export const getSelecioneSelects = (trad, trads, lingua, chavetexto) => {
    return {"texto": trad(trads,chavetexto,lingua), "value": ""};
}

export const getDadosToOptions = (dados, id, trad, trads, lingua, chavetexto) => {
    let result = [getSelecioneSelects(trad, trads, lingua, chavetexto)];
    if(dados.length){        
        result = result.concat(dados.map(itens => {
            return {
                ...itens,
                value: itens[id],
                texto: itens[lingua]
            }
        }))
    }    
    return result;
}

export const getSelecioneSelectsSemTrad = (chavetextovazio) => {
    return {"texto": chavetextovazio, "value": ""};
}

export const getDadosToOptionsSemTrad = (dados, id, campo, chavetextovazio) => {
    let result = [getSelecioneSelectsSemTrad(chavetextovazio)];
    if(dados.length){
        result = result.concat(dados.map(itens => {
            return {
                ...itens,
                value: itens[id],
                texto: itens[campo]
            }
        }))
    }    
    return result;
}

export const getCamposFormatadosValidacao = (formsPesquisaCampos) => {
    if(formsPesquisaCampos && formsPesquisaCampos.length){       
        const campos_formatados = formsPesquisaCampos.map(itens => {
            if(itens.baseform){
                return {
                    name: `${itens.baseform.campo}`,
                    obrigatorio: itens.campoobrigatorio==='S'?(itens.ocultacampo==='S'?false:true):false,
                    ocultacampo: itens.ocultacampo==='S'?true:false,
                    perguntasobrigatorias: itens.perguntasobrigatorias&&itens.perguntasobrigatorias.split("|")
                }
            }else{
                return null;
            }
       });
       return campos_formatados.filter(itens => {return itens !== null});
    }
}

export const ColunasPerguntas = (itens, trads, trad, tradCampo, lingua, styles, formstatus, md, obrigatorio = false) => {
    
    const required = value => (value ? undefined : trad(trads,'JSOBRIGATORIO',lingua));
    const required_pergunta = value => (value ? undefined : trad(trads,'JSOBRIGATORIO',lingua));
    
    return (
        <Form.Group
        as={Col} 
        md={md}
        className="align-self-top border-bottom bg-light" 
        controlId={itens.idpergunta}
        key={itens.idpergunta}        
        >
        <Form.Label  className="font-weight-bold" key={itens.idpergunta} style={styles[`p_${itens.idpergunta}`]}>{itens[tradCampo(lingua)]}</Form.Label>
            <Row xs={2} md={itens.resposta.length>9?2:12}>
            {itens.resposta.map((resp) => {                
                let prefix_campo = 'p';
                if(itens.variasrespostas&&resp.outrosespecificar==='S'){
                    prefix_campo = 'o';
                }

                const name_campo = `${prefix_campo}_${itens.idpergunta}`;
                const status = formstatus.getFieldState(name_campo);
                
                let ticado = false;
                let dados_iniciais = false;
                if(status && status.pristine === false){
                    const values = formstatus.getFieldState(name_campo)?formstatus.getFieldState(name_campo).value:[];                    
                    if(values){  
                        if(Array.isArray(values)){                            
                            const vals = values.filter(itens => (itens === `${resp.idconteudopergunta}`));
                            ticado = vals.length?true:false;
                        }else{
                            ticado = values===`${resp.idconteudopergunta}`;
                        }                    
                    }                    
                }else{
                    dados_iniciais = resp.outrosespecificar==='S'&&status&&status.initial&&Array.isArray(status.initial)?true:false;
                }
                                
                return (    
                    <Col key={'body'+resp.idconteudopergunta} sm={8}>    
                        <Card className="border border-light" style={{backgroundColor: "#f8f9fa"}}>
                            <Field
                            styles={styles}             
                            type={`${itens.variasrespostas?"checkbox":"radio"}`}
                            name={name_campo}
                            value={`${resp.idconteudopergunta}`}
                            label={resp[tradCampo(lingua)]}
                            component={camporadio} 
                            key={resp.idconteudopergunta}
                            validate={obrigatorio?required_pergunta:null}
                            />
                            {
                            (ticado&&resp.mostrarpergunta&&resp.mostrarpergunta.idpergunta)
                            ||
                            (resp.mostrarpergunta&&resp.mostrarpergunta.idpergunta&&status&&parseInt(status.value)===parseInt(resp.idconteudopergunta))?
                            ColunasPerguntas(resp.mostrarpergunta, trads, trad, tradCampo, lingua, styles, formstatus, md, true)
                            :
                            null
                            }
                            {(resp.outrosespecificar==='S'&&ticado===true) || (dados_iniciais===true)?
                            <Field         
                            styles={styles}               
                            type="text"
                            validate={required}
                            name={`outrosespecificar_${itens.idpergunta}_${resp.idconteudopergunta}`}
                            placeholder={trad(trads,'ESPECIFIQUE',lingua)}                    
                            label={resp[tradCampo(lingua)]}
                            component={campotexto} 
                            key={'outros'+resp.idconteudopergunta}
                            />
                            :
                            null
                            }
                        </Card>                                       
                    </Col>
                ) 
            })
        }
            </Row>
        </Form.Group>            
    );
}

export const LogErrorLabels = (props) => {
    const errors_labels = Object.keys(props.errors).map(campo => {
        let campo_tradado = campo.split('_');
        campo_tradado = campo_tradado[1]?campo_tradado[1]:campo_tradado[0];                
        return document.querySelector(`label[for="${campo_tradado}"]`)?document.querySelector(`label[for="${campo_tradado}"]`).innerHTML:campo_tradado;
    });
    return errors_labels;
}

export const getCamposInitialValues = (campos, initialvalues) => {    
    let result = {};
    if(Object.keys(initialvalues).length){
        campos.map(itens => {
            itens.rows.map(campos => {
                campos.map(campo => {                
                    if(initialvalues[campo.name]){
                        result = {
                            ...result,
                            [campo.name]: initialvalues[campo.name]
                        }
                    }
                    return null;
                })
                return null;
            });
            return null;
        })
    }
    return result;
}

export const getPreImagesCampo = (campo, imagens = []) => {    
    const item = imagens.filter(itens => {
        return itens.campo === campo;
    });    
    return item.length?[
        {'data_url': item[0].imagem}
    ]:[];
}